"use client";

const Header = () => {
  return <header className="hidden"></header>;
};

export default Header;
